import { Box, Button } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import React, { useCallback } from 'react';

import { HorizontalCard, VendorLine } from '../../../components/_mui';
import { ICampaignItem } from '../../../types/pyg';
import { HorizontalCardVariantEnum } from '../../../types/shell';

interface IProps {
  item: ICampaignItem;
  vendor?: string;
  onViewDetails: (item: ICampaignItem) => void;
}

const viewDetailsButtonSx: SxProps<Theme> = { minWidth: 64, height: 30 };

export const SummaryIncludedRow = ({ item, vendor, onViewDetails }: IProps) => {
  const handleViewDetails = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      onViewDetails(item);
    },
    [onViewDetails, item],
  );

  const handleCardClick = useCallback(() => onViewDetails(item), [onViewDetails, item]);

  return (
    <Box>
      <HorizontalCard
        image_url={item.image_url}
        name={item.name}
        variant={HorizontalCardVariantEnum.Suboption}
        thumbnailFit="contain"
        onClick={handleCardClick}
        ariaLabel={`View details for ${item.name}`}
        body={<VendorLine vendor={vendor} />}
      >
        <Button
          variant="text"
          size="small"
          color="primary"
          tabIndex={-1}
          onClick={handleViewDetails}
          sx={viewDetailsButtonSx}
        >
          View details
        </Button>
      </HorizontalCard>
    </Box>
  );
};
